<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © PayBuistra.</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">Designer & Développer par  <a target="_blank" href="https://swanafricatech.com/">Swan Africa Tech</a></div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
